import React, { useEffect, useState } from "react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import { Modal } from "../ui";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const [qrCode, setQrCode] = useState("");

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const socket = openSocket();

    socket.on("whatsappSession", (data) => {
      if (data.action === "update" && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);
      }

      if (data.action === "update" && data.session.qrcode === "") {
        onClose();
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [whatsAppId, onClose]);

  return (
    <Modal open={open} onClose={onClose} title="QR Code" size="sm">
      <div className="flex flex-col items-center">
        <p className="text-primary-600 dark:text-primary-400 text-center mb-4">
          {i18n.t("qrCode.message")}
        </p>
        {qrCode ? (
          <div className="p-4 bg-white rounded-lg shadow-sm">
            <img
              src={qrCode}
              alt="QR Code"
              width={256}
              height={256}
              className="block"
            />
          </div>
        ) : (
          <div className="flex items-center justify-center h-64 w-64 bg-dark-100 dark:bg-dark-700 rounded-lg">
            <div className="flex flex-col items-center gap-3">
              <svg
                className="animate-spin h-8 w-8 text-primary-500"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              <span className="text-sm text-dark-500 dark:text-dark-400">
                Aguardando QR Code...
              </span>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default React.memo(QrcodeModal);
